import { useState } from "react";
import { updateLinksToOpenInNewTabs } from "./urlUtils";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { cleanPromoDescription } from "./promotionUtils";
import TermsAndConditionsAccordion from "../../../TermsAndConditionsAccordion/TermsAndConditionsAccordion";
import styles from "./SpecialOffersPromotion.module.scss";
import { Message } from "../../../../types/types";

interface SpecialOffersPromotionProps {
  promotion: Message;
  drawerIsOpen: boolean;
  onClose: () => void;
}

const SpecialOffersPromotion = ({
  promotion,
  drawerIsOpen,
  onClose,
}: SpecialOffersPromotionProps) => {
  const [buttonIsClicked, setButtonIsClicked] = useState(false);

  const findPromoCode = (content: string | null) => {
    const promoCodeRegexPattern = /(Apply promo code )([\w]*)( at checkout)/;
    const promoCodeMatches = content?.match(promoCodeRegexPattern);
    return promoCodeMatches ? promoCodeMatches[2] : "";
  };

  const copyPromoCode = (promoCode: string) => {
    navigator.clipboard.writeText(promoCode);
    setButtonIsClicked(true);
  };

  let promoCode = findPromoCode(promotion.title);
  if (!promoCode) {
    promoCode = findPromoCode(promotion.description!);
  }
  const cleanDescription = cleanPromoDescription(promotion);
  const updatedLinksDescription = updateLinksToOpenInNewTabs(cleanDescription);
  const [description, terms] = updatedLinksDescription.split(
    "<strong>Terms and conditions</strong>",
  );
  const isTradeInPromotion = promotion?.promotionType === "Trade In - Enhanced";

  return (
    <div
      className={styles.SpecialOffersDrawer__promo}
      data-testid="special-offers-drawer-promotion"
    >
      <h3 className={styles.SpecialOffersDrawer__promoTitle}>
        {promotion.title}
      </h3>
      <div
        className={styles.SpecialOffersDrawer__promoDescription}
        dangerouslySetInnerHTML={{
          // @ts-ignore
          __html: description,
        }}
      />
      {terms && <TermsAndConditionsAccordion terms={terms} />}
      <div
        data-testid="special-offer-buttons"
        className={styles.SpecialOffersDrawer__buttonContainer}
      >
        {promoCode && (
          <SecondaryButton
            disabled={buttonIsClicked || !drawerIsOpen}
            id={`copyPromoButton${promoCode}`}
            className={styles.SpecialOffersDrawer__copyPromoButton}
            // @ts-ignore
            onClick={() => copyPromoCode(promoCode)}
          >
            {buttonIsClicked ? "Copied" : "Copy promo code"}
          </SecondaryButton>
        )}
        {isTradeInPromotion && (
          <SecondaryButton
            className={styles.SpecialOffersDrawer__tradeInCTAButton}
            onClick={onClose}
          >
            Trade in device
          </SecondaryButton>
        )}
      </div>
    </div>
  );
};

export default SpecialOffersPromotion;
